// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161350/js/" + chunkId + "." + {"44":"5aea4b50","225":"abede974","481":"7abe5e9e","486":"47c6a47e","770":"197e6a62"}[chunkId] + ".0.04071427406136885.chunk.js";
};